import React, { useEffect, useState, useRef } from "react";
import GameBoard from "../components/Ani/8_March_MemoryGame/GameBoard";
import MessageReveal from "../components/Ani/8_March_MemoryGame/MessageReveal";
import IntroModal from "../components/Ani/8_March_MemoryGame/IntroModal";
import FinalOverlay from "../components/Ani/8_March_MemoryGame/FinalOverlay";
import HeartsLayer from "../components/Ani/8_March_MemoryGame/HeartsLayer";
import { shuffle } from "../utils/Ani/shuffle";
import confetti from "canvas-confetti";
import "../styles/Ani_8MarchMemoryGame.css";

import ani1 from "../assets/images/ani/8_March_MemoryGame/ani1.jpg";
import ani2 from "../assets/images/ani/8_March_MemoryGame/ani2.jpg";
import ani3 from "../assets/images/ani/8_March_MemoryGame/ani3.png";
import ani4 from "../assets/images/ani/8_March_MemoryGame/ani4.jpg";
import ani5 from "../assets/images/ani/8_March_MemoryGame/ani5.jpg";
import ani6 from "../assets/images/ani/8_March_MemoryGame/ani6.jpeg";
import ani7 from "../assets/images/ani/8_March_MemoryGame/ani7.jpeg";
import ani8 from "../assets/images/ani/8_March_MemoryGame/ani8.jpeg";
import ani9 from "../assets/images/ani/8_March_MemoryGame/ani9.png";
import ani10 from "../assets/images/ani/8_March_MemoryGame/ani10.jpeg";
import ani11 from "../assets/images/ani/8_March_MemoryGame/ani11.jpeg";
import ani12 from "../assets/images/ani/8_March_MemoryGame/ani12.jpeg";

import matchSoundFile from "../assets/sounds/ani/match_sound.mp3";

const MESSAGE = "ЧЕСТИТ 8-МИ МАРТ, АНИ! ОБИЧАМ ТЕ!";

const images = [ ani1, ani2, ani3, ani4, ani5, ani6, ani7, ani8, ani9, ani10, ani11, ani12 ];

export default function MemoryGamePage() {

  const [cards, setCards] = useState([]);
  const [flipped, setFlipped] = useState([]);
  const [matches, setMatches] = useState(0);
  const [gameStarted, setGameStarted] = useState(false);
  const [gameFinished, setGameFinished] = useState(false);
  const [revealedLetters, setRevealedLetters] = useState(0);
  const matchSound = useRef(new Audio(matchSoundFile));

  useEffect(() => { // Initialize the game board with shuffled cards (each image appears twice - pairs)
    const duplicated = [...images, ...images];

    const deck = duplicated.map((img, i) => ({
      id: i,
      image: img,
      flipped: false,
      matched: false
    }));

    setCards(shuffle(deck)); // Shuffle the cards at the start of the game
  }, []);

  useEffect(() => {
    if (flipped.length === 2) { // Two cards are flipped

      const [first, second] = flipped;

      if (cards[first].image === cards[second].image) { // In case of a match

        const newCards = [...cards];
        newCards[first].matched = true;
        newCards[second].matched = true;

        // Play match sound effect
        matchSound.current.currentTime = 0;
        matchSound.current.play().catch(() => {});

        setCards(newCards);
        setMatches(m => m + 1);
        setRevealedLetters(l => l + 2); // Reveal 2 more letters (for each matched pair)
        setFlipped([]);

      } else { // If there is no match - flip back after a short delay

        setTimeout(() => {
          const newCards = [...cards];
          newCards[first].flipped = false;
          newCards[second].flipped = false;
          setCards(newCards);
          setFlipped([]);
        }, 800);

      }

    }
  }, [flipped, cards]);

  useEffect(() => {
    if (matches === 12) { // Check if the game is finished (if all 12 pairs are matched)
      setGameFinished(true);
      confetti({ particleCount: 80, spread: 60 });
      setTimeout(() => {
        confetti({ particleCount: 80, spread: 100 });
      }, 400);
    }
  }, [matches]);

  const handleCardClick = (index) => {

    if (gameFinished) return; // Prevent clicking after game is finished
    if (flipped.length === 2) return;
    if (cards[index].flipped) return; // Prevent clicking the same card twice
    if (cards[index].matched) return; // Prevent clicking 3rd card while 2 are flipped

    const newCards = [...cards];
    newCards[index].flipped = true;

    setCards(newCards);
    setFlipped(prev => [...prev, index]); // Ensure we work with the latest state of flipped cards. This is crucial to avoid issues with stale state when rapidly clicking cards.

  };

  return (
    <div className={`march8-memory-page ${gameFinished ? "blur" : ""}`}>

      {!gameStarted && (
        <IntroModal onStart={() => setGameStarted(true)} />
      )}

      <MessageReveal
        message={MESSAGE}
        revealed={revealedLetters}
      />

      <GameBoard
        cards={cards}
        onCardClick={handleCardClick}
      />

      {gameFinished && (
        <>
          <HeartsLayer />
          <FinalOverlay />
        </>
      )}

    </div>
  );
}